module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/depth_views/2-18f7d32569a0a891a2691e136af1fbdd.jpg";